import { WorkOpportunitiesTab } from "../constants/work_opportunities_tab";
import { FiltersData } from "../contexts/marketplace_context.types";

export const getTabFilters = (
  filtersData: FiltersData,
  tab: WorkOpportunitiesTab
): FiltersData["filters"] | undefined => (filtersData.tab === tab ? filtersData.filters : {});
